import { render, staticRenderFns } from "./driverDetail.vue?vue&type=template&id=7f1a0636&scoped=true&"
import script from "./driverDetail.vue?vue&type=script&lang=js&"
export * from "./driverDetail.vue?vue&type=script&lang=js&"
import style0 from "./driverDetail.vue?vue&type=style&index=0&id=7f1a0636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1a0636",
  null
  
)

export default component.exports